const PAGE_PREFIXES = {
  compare: '/credit-cards/compare',
  review: '/credit-cards/reviews',
  roundup: '/credit-cards/best',
  'paid-roundup': '/credit-cards/m/best',
} as const;

export function getPagePrefix(pageType: keyof typeof PAGE_PREFIXES) {
  return PAGE_PREFIXES[pageType];
}
